import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import {
  Address,
  CalendarOutput,
  OrderDeliveryType,
  orderStatusTranslation,
} from "@/interfaces";
import { useNavigate } from "react-router-dom";
import { formatCep } from "@/util/formatters";

interface OrderDetailsModalProps {
  order: CalendarOutput;
  onClose: () => void;
}

function formatAddress(address: Address): string {
  const {
    line1 = "",
    number = "",
    line2 = "",
    neighborhood = "",
    city = "",
    zipCode = "",
  } = address;

  return `${line1}${number ? `, ${number}` : ""}${line2 ? ` - ${line2}` : ""},
          ${neighborhood.trim()}${
    neighborhood && city ? ", " : ""
  }${city.trim()}
          ${zipCode ? ` - ${formatCep(zipCode)}` : ""}`;
}

export const DeveliryCalendarOrderDetailsModal: React.FC<
  OrderDetailsModalProps
> = ({ order, onClose }) => {
  const navigate = useNavigate();

  const handleNavigate = (route: string) => {
    navigate(route);
  };

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="w-[90vw] max-w-[425px] p-4 sm:p-6">
        <DialogHeader>
          <DialogTitle className="text-lg sm:text-xl">
            Pedido {order.orderId}
          </DialogTitle>
        </DialogHeader>
        <DialogDescription asChild>
          <div className="space-y-2 text-sm sm:text-base">
            {order.orderDeliveryType === OrderDeliveryType.DELIVERY && (
              <div>
                <span className="font-semibold">Data de Entrega:</span>{" "}
                {format(
                  order.orderDeliveryAt!,
                  "dd 'de' MMMM 'de' yyyy 'às' HH:mm",
                  {
                    locale: ptBR,
                  }
                )}
              </div>
            )}
            {order.orderDeliveryType === OrderDeliveryType.WITHDRAWAL && (
              <div>
                <span className="font-semibold">Data do pedido:</span>{" "}
                {format(order.orderDate, "dd 'de' MMMM 'de' yyyy 'às' HH:mm", {
                  locale: ptBR,
                })}
              </div>
            )}

            {order.customerName && (
              <div>
                <span className="font-semibold">Cliente:</span>{" "}
                {order.customerName}
              </div>
            )}

            {order.address && (
              <div>
                <span className="font-semibold">Endereço:</span>{" "}
                {formatAddress(order.address)}
              </div>
            )}
            <div>
              <span className="font-semibold">Status:</span>{" "}
              {orderStatusTranslation[order.orderStatus]}
            </div>
          </div>
        </DialogDescription>
        <DialogFooter>
          <Button
            variant="default"
            onClick={() => handleNavigate(`/pedidos/${order.orderId}`)}
            className="w-full sm:w-auto"
          >
            Ir para o pedido
          </Button>
          <Button
            variant="outline"
            onClick={onClose}
            className="w-full sm:w-auto"
          >
            Fechar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
